module.exports = __webpack_public_path__ + "static/media/icon_color_palette.bf3bee24.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_color_palette.svg
// module id = 705
// module chunks = 0